import { createContext } from 'react';
import type { User, LoginRequest, LoginResponse } from '../types';

export interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (data: LoginRequest) => Promise<void>;
  loginWithQrTokens: (response: LoginResponse) => void;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
